import initialState from './../../initialState';
export default (state = initialState.notificacao, { type, value, response }) => {
  switch (type) {
    case 'CLOSE_NOTIFICACAO_REQUEST':
      return {
        ...state,
        notificacoes: {
          ...state.notificacoes,
          result: state.notificacoes.result.filter(v => v !== value)
        }
      };
    case 'CLOSE_ALL_NOTIFICACAO_REQUEST':
      return {
        ...state,
        notificacoes: {
          ...state.notificacoes,
          result: []
        }
      };
    case 'LIST_CONFIGURACOES_SUCCESS':
      return {
        ...state,
        configuracoes: {
          ...state.configuracoes,
          fetching: 2,
          ...response
        }
      };
    case 'LIST_NOTIFICACOES_SUCCESS':
      return {
        ...state,
        notificacoes: {
          ...state.notificacoes,
          fetching: 2,
          ...response
        }
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/notificacao/reducer.js